import { InputNumber } from "primereact/inputnumber"
import { Slider } from "primereact/slider"

import { useState } from "react"
import { useEffect } from "react"

export default function MapSearchRangeSlider({
  isLoading,
  rangeValue,
  onChange,
  maxValue,
}) {
  const [range, setRange] = useState(rangeValue)
  const maximumRange = maxValue || 4500

  useEffect(() => {
    if (range !== rangeValue) {
      setRange(rangeValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rangeValue])

  return (
    <div>
      <InputNumber
        style={{ width: "100%" }}
        inputStyle={{ width: "100%", textAlign: "center" }}
        value={range}
        maxFractionDigits={0}
        min={0}
        max={maximumRange}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onChange(parseFloat(e.currentTarget.value.replace(/,/g, "")))
          }
        }}
        onBlur={(e) => {
          const value = parseFloat(e.target.value.replace(/,/g, ""))
          if (value !== rangeValue) {
            onChange(value)
          }
        }}
        disabled={isLoading}
      />
      <Slider
        value={range}
        min={0}
        max={maximumRange}
        onChange={(e) => {
          if (e.value !== range) {
            setRange(e.value)
          }
        }}
        onSlideEnd={(e) => {
          onChange(e.value)
        }}
        disabled={isLoading}
      />
    </div>
  )
}
